import React from 'react';
import {LauncherComponentBase} from '../base-components/launcher-component-base';
import ListItem from '@material-ui/core/ListItem';
import Link from '@material-ui/core/Link/Link';

export interface LauncherLinkComponentProps {
    path: string;
    text: string;
}

export class LauncherLinkComponent extends LauncherComponentBase<LauncherLinkComponentProps> {

    private _handleClick = () => {
        this.services.drawer.toggleDrawer();
        this.services.routing.navigate(this.props.path)
    };

    render() {
        return (
            <ListItem component='button' button onClick={this._handleClick} >
                <Link>{this.props.text}</Link>
            </ListItem>
        );
    }
}